import React, { Component } from 'react';
import Paper from 'material-ui/Paper';

import * as firebase from 'firebase';
import * as firebaseui from 'firebaseui';

import 'firebaseui/dist/firebaseui.css';
import './Login.css';
import screen6_logo from '../../media/screen6-logo-blue-on-transparent.svg';

class LoginPanel extends Component {

  componentDidMount() {
    // FirebaseUI config.
    this.uiConfig = {
      callbacks: {
        // Called when the user has been successfully signed in.
        signInSuccessWithAuthResult:  () => false
      },
      // Opens IDP Providers sign-in flow in a popup.
      signInFlow: 'popup',
      signInOptions: [
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        firebase.auth.GoogleAuthProvider.PROVIDER_ID
      ]
    };

    // Initialize the FirebaseUI Widget using Firebase. (Do this only once per browser session)
    if (!global.firebaseAuthUI) {
      global.firebaseAuthUI = new firebaseui.auth.AuthUI(firebase.auth());
    }
    // The start method will wait until the DOM is loaded.
    global.firebaseAuthUI.start('#firebaseui-auth-container', this.uiConfig);
  }

  componentWillUnmount() {
    global.firebaseAuthUI.reset();
  }

  render() {
    const styles = {
      h2: {
        marginBottom: 0,
      },
      h3: {
        marginTop: 5,
        marginBottom: 50,
      },
      contentBlock: {
        paddingTop: 40,
      },
    }
    return (
      <div className="LoginPanel">
        <div className="PageHeader">
          <h1><HeadingLogo/>Login</h1>
          <h2 style={styles.h2}>Screen6 Hub</h2>
          <h3 style={styles.h3}>Data Hookups Happen Here</h3>
        </div>
        <Paper zDepth={1} className="ContentSpacing" style={styles.contentBlock}>
          <p>Please sign in with your email address.</p>
          <div id="firebaseui-auth-container"></div>
          <p>To request access, select "Sign in with email" and create your login. Screen6 ops will be notified of your request.</p>
        </Paper>
      </div>
    )
  }
}

const HeadingLogo = () => {
  const logoStyle = { margin: '7px 5px 0px 0px', verticalAlign: 'sub' }
  return (
    <img src={screen6_logo} alt="logo" height="26" style={logoStyle} />
  );
}

export default LoginPanel



// WEBPACK FOOTER //
// ./src/containers/Login/index.jsx